// import { Store } from "../state/store";
import Message from "../sections/message";
// import { getApi } from "../services/api";
// import { setError } from "../services/dom";
import { getStringFromLocalStorage } from "../services/localStorage";
// import { RecipeDb } from "../services/indexeddb/recipeDb";
import {
  // AppState,
  RoutePage,
} from "../types";
// import { IRecipe } from "../types/recipe";
import { RecipeStore } from "../services/stores/recipeStore";
import { IngredientStore } from "../services/stores/ingredientStore";
import { UnitStore } from "../services/stores/unitStore";
import { PlanStore } from "../services/stores/planStore";
import { ShoppingListStore } from "../services/stores/shoppingListStore";
import { PlanTemplateStore } from "../services/stores/planTemplateStore";
import { RecipeBookStore } from "../services/stores/recipeBookStore";
import { InventoryStore } from "../services/stores/inventoryStore";

export class Page {
  public recipeStore = RecipeStore.getInstance();
  public ingredientStore = IngredientStore.getInstance();
  public unitStore = UnitStore.getInstance();
  public planStore = PlanStore.getInstance();
  public shoppingListStore = ShoppingListStore.getInstance();
  public planTemplateStore = PlanTemplateStore.getInstance();
  public recipeBookStore = RecipeBookStore.getInstance();
  public inventoryStore = InventoryStore.getInstance();
  public message: Message;
  public apiUrl = import.meta.env.VITE_API_URL as string;
  public apiToken = getStringFromLocalStorage("idToken");
  constructor(pageContent: string) {
    document.querySelector<HTMLDivElement>("#app")!.innerHTML = pageContent;
    this.message = new Message();
  }

  async init(): Promise<void> {
    await Promise.all([
      this.recipeStore.ready(),
      this.ingredientStore.ready(),
      this.unitStore.ready(),
      this.planStore.ready(),
      this.shoppingListStore.ready(),
      this.planTemplateStore.ready(),
      this.recipeBookStore.ready(),
      this.inventoryStore.ready(),
    ]);
  }

  // async getRecipes(): Promise<void> {
  //   try {
  //     const recipes = await this.recipeDb.getRecipes();
  //     if (recipes.length === 0) {
  //       const recipes = await getApi(this.apiUrl, "recipe", this.apiToken);
  //       recipes.forEach((recipe: IRecipe) => {
  //         this.recipeDb.addRecipe(recipe);
  //       });
  //     }
  //   } catch (e: any) {
  //     this.message.timedMessage(`⚠ Unexpected error getting inventory ⚠`);
  //     console.log(e);
  //     setError("inventory");
  //   }
  // }

  handleCustomAttributes(): void {
    // Handle ToggleSections (button with div as child, clicking button toggles 'hidden' class)
    const toggleSections = document.querySelectorAll("[data-toggle-section]");
    toggleSections.forEach((toggleSection) => {
      const toggleSectionName = toggleSection.attributes.getNamedItem("data-toggle-section")?.value;
      toggleSection.addEventListener("click", () => {
        console.log(`getting section '${toggleSectionName}_hideable'`);
        const section = document.getElementById(`${toggleSectionName}_hideable`) as HTMLDivElement;
        section.classList.toggle("hidden");
      });

      // Handle Data Models (input with value that is kept in state as it changes)
      // const dataModels = document.querySelectorAll("[data-model]");
      // dataModels.forEach((dataModel) => {
      //   const storeName = dataModel.attributes.getNamedItem("data-store")?.value;
      //   const storeKey = dataModel.attributes.getNamedItem("data-model")?.value;
      //   dataModel.addEventListener("change", () => {
      //     this.store.set()
      //   })
      // });
    });
  }
}

export enum Pages {
  LOGIN = "login",
  REGISTER = "register",
  HOME = "home",
  RECIPE = "recipe",
  NOTFOUND = "notfound",
  PLAN = "plan",
  SHOPPINGLIST = "shoppinglist",
  PANTRY = "pantry",
  PLANTEMPLATE = "plantemplate",
  PROFILE = "profile",
  HOUSEHOLD_SETUP = "household-setup",
}

export const RoutePages: RoutePage[] = [
  {
    path: "",
    page: Pages.HOME,
  },
  {
    path: "/home",
    page: Pages.HOME,
  },
  {
    path: "/404",
    page: Pages.NOTFOUND,
  },
  {
    path: "/login",
    page: Pages.LOGIN,
  },
  {
    path: "/register",
    page: Pages.REGISTER,
  },
  {
    path: "/recipe",
    page: Pages.RECIPE,
  },
  {
    path: "/plan",
    page: Pages.PLAN,
  },
  {
    path: "/shoppinglist",
    page: Pages.SHOPPINGLIST,
  },
  {
    path: "/pantry",
    page: Pages.PANTRY,
  },
  {
    path: "/plantemplate",
    page: Pages.PLANTEMPLATE,
  },
  {
    path: "/profile",
    page: Pages.PROFILE,
  }
];
